
const ImageTagsDetails = ({ mediaId, isretailer = false, className = "" }) => {

  return <a href={`${!isretailer ? '/image-metadata' : '/product-metadata'}/${mediaId}`} className={`font-medium hover:underline ${className}`} target='_blank'>Metadata</a>
}

export default ImageTagsDetails;
